export { formatDateTime } from '@/utils/formatDateTime'

/**
 * Clock label for the admin meetings Duration column.
 *
 * Every row uses `hh:mm:ss`. A short meeting printed as `0:45` sits next to
 * an hour-long `1:01:01` and reads as hours and minutes.
 *
 * @param seconds Recorded length. Negative or non-finite values read as zero.
 * @returns Zero-padded `hh:mm:ss`. Hours grow past 99 instead of wrapping.
 */
export function formatAdminMeetingDuration(seconds: number): string {
  const total = Number.isFinite(seconds) ? Math.max(0, Math.floor(seconds)) : 0
  const hours = Math.floor(total / 3600)
  const minutes = Math.floor((total % 3600) / 60)
  const secs = total % 60
  return [hours, minutes, secs].map((part) => String(part).padStart(2, '0')).join(':')
}

/**
 * Converts a `<input type="date">` value (YYYY-MM-DD) to a start-of-day epoch
 * in ms, or undefined when empty.
 */
export function dateInputToStartMs(value: string): number | undefined {
  if (!value) return undefined
  const ms = new Date(`${value}T00:00:00`).getTime()
  return Number.isNaN(ms) ? undefined : ms
}

/**
 * Converts a `<input type="date">` value (YYYY-MM-DD) to an end-of-day epoch
 * in ms, or undefined when empty.
 */
export function dateInputToEndMs(value: string): number | undefined {
  if (!value) return undefined
  const ms = new Date(`${value}T23:59:59.999`).getTime()
  return Number.isNaN(ms) ? undefined : ms
}
